import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootEl = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If the HTML shell was pre-rendered by our build-time snapshot script,
// hydrate (attach event handlers to existing DOM) instead of re-rendering.
// This preserves the SEO snapshot Google indexed and gives a smoother FCP.
if (document.documentElement.getAttribute("data-prerendered") === "true" && rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, app);
} else {
  ReactDOM.createRoot(rootEl).render(app);
}
